import { Modal, Paper, Tab, Tabs } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { ActiveDate } from "src/scenes/dashboard/date-provider";
import { endOfDay, subMonths } from "date-fns";
import { useAuth } from "src/components/providers/auth-context";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link as RouteLink } from "react-router-dom";
import DateRangePickerNew from "src/components/date-range-picker-new";
import SprintPickerModal from "src/components/sprint-picker-modal";

const ModalContainer = styled(Paper)`
    position: absolute;
`;

const RangePickerModal = ({ handleClose, open, toggleDatepicker, isRepo, isTeams }) => {
    const [value, setValue] = React.useState("dates");
    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    const { isUserPayingCustomer } = useAuth();
    const FreeloaderLimiter = isUserPayingCustomer ? undefined : subMonths(new Date(), 3);

    const { handleChange } = React.useContext(ActiveDate);
    const maxDate = endOfDay(new Date());

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
            <ModalContainer>
                <Stack direction="column">
                    <Tabs value={value} onChange={handleTabChange} centered>
                        <Tab label="Select Dates" value="dates">
                            Select Dates
                        </Tab>
                        <Tab label="Select Sprints" value="sprints" disabled={isRepo}>
                            Select Sprints
                        </Tab>
                    </Tabs>
                    {value === "dates" && (
                        <DateRangePickerNew
                            minDate={FreeloaderLimiter}
                            maxDate={maxDate}
                            handleChange={handleChange}
                            toggleDatepicker={toggleDatepicker}
                        />
                    )}
                    {value === "sprints" && (
                        <SprintPickerModal isTeams={isTeams} handleClose={handleClose} />
                    )}
                    {FreeloaderLimiter && (
                        <>
                            <Typography sx={{ p: 2 }}>
                                Get unlimited access to historical data whilst feeding your favorite
                                development team.
                            </Typography>
                            <Button
                                component={RouteLink}
                                aria-describedby="simple-popover"
                                to="/upgrade"
                                variant="contained"
                            >
                                Upgrade Now
                            </Button>
                        </>
                    )}
                </Stack>
            </ModalContainer>
        </Modal>
    );
};
export default RangePickerModal;
